export const getEmbeddedVideoUrl = (url: string): string | null => {
	try {
		const parsedUrl = new URL(url);

		// YouTube
		if (
			parsedUrl.hostname.includes('youtube.com') ||
			parsedUrl.hostname.includes('youtu.be')
		) {
			const videoId =
				parsedUrl.searchParams.get('v') || parsedUrl.pathname.split('/').pop();
			return `https://www.youtube.com/embed/${videoId}`;
		}

		// Vimeo
		if (parsedUrl.hostname.includes('vimeo.com')) {
			const videoId = parsedUrl.pathname.split('/').pop();
			return `https://player.vimeo.com/video/${videoId}`;
		}

		return null;
	} catch (err) {
		return null;
	}
};
